<div class="list-group-item border-left-width mb-1"
    [ngClass]="{'border-left-warning': reservation.status === 1, 'border-left-success': reservation.status !== 1}">
    <div class="row">
        <div [ngClass]="{'col-12 col-md-11': reservation.status === 1, 'col-12': reservation.status !== 1}">
            <div class="d-flex w-100 justify-content-between">
                <h4 class="mb-1">{{reservation.name}}</h4>
                <small> {{'USER.RESERVATIONS.ITEM.reservationCode' | translate}} <br />
                    <strong>{{reservation.reservationCode}}</strong></small>
            </div>
            <hr />
            <div class="row">
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.persons' | translate}} : </strong>
                    <p class="m-0">{{reservation.reservedPersons}}</p>
                </div>
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.timeSlot' | translate}} : </strong>
                    <p class="m-0">{{reservation.timeSlot}}</p>
                </div>
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.date' | translate}} : </strong>
                    <p class="m-0">{{reservation.reservationDate | date: 'dd-MM-yyyy'}}</p>
                </div>
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.phone' | translate}} : </strong>
                    <p class="m-0">{{reservation.phone}}</p>
                </div>
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.email' | translate}} : </strong>
                    <p class="m-0">{{reservation.email}}</p>
                </div>
            </div>
            <hr />
            <div class="form-group">
                <strong> {{'USER.RESERVATIONS.ITEM.comment' | translate}} : </strong>
                <p class="help-text">{{reservation.comment}}</p>
            </div>
        </div>
        <div class="col-1 justify-content-between text-center d-none d-sm-block"
            *ngIf="reservation.status === 1 && dateDiff === 0">
            <button type="button" class="btn btn-link" (click)="onReservationApproveClick(index)">
                <fa-icon [icon]="icons['faCheck']" style="line-height: 11rem; font-size: 24px;"></fa-icon>
            </button>
        </div>
    </div>
</div>